import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SalesForceIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof SalesForceIntegrationResponseDataSchema>>

const queryKey = ["salesForceIntegration"]

export const salesForceIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/salesForce/configuration`)

      return response.data.data
    },
  })
}
